export const IN_DEV_FEATURE_FLAG = 'development';
